import type {SuggestLocation} from '@yandex-delivery/api/model/suggest'
import {SuggestAction} from '@yandex-delivery/api/model/suggest'
import {merge, pipe} from '@yandex-delivery/utils'

import type {AddressSuggestResponse, Order as FormValues} from '../../types'
import {fromPinDropToPointAddress} from '../../utils'
import {suggestService} from './fetch-address-suggest'

const {fetchAddressSuggest} = suggestService
export async function fetchInitialLocation(location: SuggestLocation, onError: (error: Error) => void) {
  const sourcePoint = await fetchAddressSuggest({
    point: location,
    type: 'a',
    location,
    action: SuggestAction.PIN_DROP,
  })
    .then(res => res as unknown as AddressSuggestResponse)
    .then(fromPinDropToPointAddress)
    .catch(error => {
      onError(error)
    })
  const initialLocation = {
    sourcePoint: {
      address: sourcePoint,
    },
  }

  return function _withInitialLocation(formValues: FormValues): FormValues {
    return pipe(initialLocation, merge(formValues))
  }
}
